import { Trans, useTranslation } from "react-i18next";
import {
    useGradingComparison,
    useScreeningGradingComparison
} from "../../queries/gradeComparisonQueries";
import { showRequestErrorToast } from "../../services/ErrorService";
import { Loading } from "../loading/Loading";
import { GradeComparison as GradeComparisonCharts } from "@idwal/idwal-react-components";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useParams } from "react-router-dom";
import { APIGrade } from "@idwal/idwal-react-components/dist/types/APIGrade";

type Props = {
    imo: string | undefined;
    vesselGrade: APIGrade | undefined;
    vesselGradeRange?: string;
};

export const GradeComparison = (props: Props) => {
    const { imo, vesselGrade, vesselGradeRange } = props;

    const { t } = useTranslation("locale");
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);
    const { inspectionId } = useParams();

    const { data, isError, error, isLoading } = useScreeningGradingComparison(
        imo ?? "",
        user
    );

    const {
        data: comparison,
        isError: comparisonIsError,
        error: comparisonError,
        isLoading: comparisonIsLoading
    } = useGradingComparison(inspectionId ?? "", user);

    if (isLoading || comparisonIsLoading) {
        return <Loading />;
    }

    if (isError || comparisonIsError) {
        console.error(error);
        console.error(comparisonError);
        showRequestErrorToast("Grading");
        return <div></div>;
    }

    if (!comparison) {
        return (
            <div className={"grid"}>
                <div className={"lg:col-8 col-10"}>
                    <p>{t("grade_comparison.unavailableExplanation1")}</p>
                    <br />
                    <p>
                        <Trans
                            i18nKey="grade_comparison.unavailableExplanation2"
                            t={t}
                        >
                            If you would like further information on how this
                            vessel compares to others in the market, please
                            <a
                                className={"portal-link"}
                                href="https://www.idwalmarine.com/contact-us"
                                target="_blank"
                                rel="noreferrer"
                            >
                                contact us
                            </a>
                            .
                        </Trans>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <GradeComparisonCharts
            imageUrls={[
                comparison.gradeDistributionGraphUrl,
                comparison.ageRangeGraphUrl
            ]}
            type={data.type}
            ageRange={data.age_range}
            vesselAge={Number(data.age)}
            vesselGrade={vesselGrade}
            vesselGradeRange={vesselGradeRange}
        />
    );
};
